/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useMemo,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { Droppable } from 'react-beautiful-dnd';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';

const { lPink, lGrey0, lGrey1 } = colors;

const MatchDrop = props => {
  const { droppableId, isDropDisabled = false, style, children } = props;

  const context = useContext(interactionContext);
  const {
    dropZoneColor = lGrey1,
    panelWidth = 250,
    panelHeight = 250,
  } = context.props;

  const mediaType = children[0].props.child;

  return (
    <Droppable
      droppableId={`drop_${droppableId}`}
      type="drop"
      isDropDisabled={isDropDisabled}
    >
      {provided => (
        <div
          ref={provided.innerRef}
          className="droppable-container"
          css={css`
            position: relative;
            width: ${panelWidth}px;
            height: ${panelHeight}px;
            margin: 10px;
            text-align: center;
            background: ${'transparent' || '#fff' || lGrey1};
            ${!isDropDisabled && `border: 2px dashed ${dropZoneColor};`}
            border-radius: 5px;
            overflow:hidden;
          `}
          style={style}
        >
          <div
            css={css`
              position: absolute;
              display: flex;
              align-items: center;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              padding: ${mediaType === 0 ? '10px' : '0px'};
            `}
          >
            {children}
          </div>

          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default MatchDrop;
